import { ChartOptions } from 'chart.js'
import React, { FunctionComponent, useState } from 'react'
import { defaults, Pie } from 'react-chartjs-2'
import { BoldText } from '../../../theme/typography'
import * as S from './styled'
import { ReactComponent as PlusSign } from '../../atoms/Icons/addPlusSign.svg'
import { ReactComponent as MinusSign } from '../../atoms/Icons/decreaseMinusSign.svg'
type OwnProps = {
  data: any
}

type Props = OwnProps

const options = {
  responsive: true,

  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'left',
      onClick: () => undefined,
      labels: {
        usePointStyle: true,
        padding: 20,
      },
    },
  },
} as ChartOptions<'pie'>

const PieChart: FunctionComponent<Props> = ({ data }) => {
  defaults.font.family = 'Inter'

  const [modalOpen, setModalOpen] = useState(false)
  function handleClick() {
    setModalOpen(prev => !prev)
  }

  return (
    // <S.DivStyled onClick={handleClick} modalOpen={modalOpen}>
    <S.Chart modalOpen={modalOpen}>
      {modalOpen ? (
        <MinusSign
          style={{ position: 'absolute', top: '10px', right: '10px', width: '25px' }}
          onClick={handleClick}
        />
      ) : (
        <PlusSign
          style={{ position: 'absolute', top: '10px', right: '10px', width: '25px' }}
          onClick={handleClick}
        />
      )}
      <S.ChartHeader>
        <BoldText color={'#333B69'}>Fördelning av ägg</BoldText>
      </S.ChartHeader>
      <S.ChartBody>
        <Pie options={options} data={data} style={{ height: 205 }} />
      </S.ChartBody>
    </S.Chart>
    // </S.DivStyled>
  )
}

export default PieChart
